import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Import your flag images (make sure to add these files to your project)
import englishFlag from '../../assets/images/english-flag.png';
import arabicFlag from '../../assets/images/uae-flag.png';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
    setOpen(false);
    window.location.reload(); // Remove if you don't need hard refresh
  };

  // Get current language flag
  const currentFlag = i18n.language === 'ar' ? arabicFlag : englishFlag;

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={() => setOpen(!open)}
        className="inline-flex justify-center items-center w-full rounded-md px-3 py-2 text-sm font-medium text-gray-700 focus:outline-none"
      >
        <img
          src={currentFlag}
          alt="Current language"
          className={`w-10 object-cover ${i18n.language === 'ar'? 'ml-2' : 'mr-2'}`}
        />
        <svg
          className="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="#000000"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.085l3.71-3.855a.75.75 0 111.08 1.04l-4.24 4.405a.75.75 0 01-1.08 0L5.25 8.27a.75.75 0 01-.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {open && (
        <div className="origin-top-right absolute right-0 mt-2 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
          <div className="py-1">
            <button
              onClick={() => changeLanguage('en')}
              className={`flex items-center w-full p-3 text-sm gap-2 ${
                i18n.language === 'en' ? 'bg-gray-100' : 'text-gray-700'
              } hover:bg-gray-100`}
            >
              <img
                src={englishFlag}
                alt="English"
                className="w-10 object-cover "
              />
              English
            </button>
            <button
              onClick={() => changeLanguage('ar')}
              className={`flex items-center w-full p-3 text-sm gap-2 ${
                i18n.language === 'ar' ? 'bg-gray-100' : 'text-gray-700'
              } hover:bg-gray-100`}
            >
              <img
                src={arabicFlag}
                alt="العربية"
                className="w-10 object-cover "
              />
              العربية
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
